import { Spin } from 'antd';
import React from 'react';

const ContentSpinner = ({ size = 'medium', height = 'h-100', className = '' }) => {
  return (
    <div className={`d-flex justify-content-center align-items-center ${height} ${className}`}>
      <Spin size={size} style={{ height: 20 }} />
    </div>
  );
};

export default ContentSpinner;
